// src/mixins/vataMixin.js
import axios from 'axios'
import { nextTick, h } from 'vue'
import MotionLoader from '../webwidgets/Components/MotionLoader.vue'

export default {
  components: {
    MotionLoader
  },
  
  props: {
    id:     { type: String, default: null },
    domain: { type: String, default: null },
    name:   { type: String, default: null },
    hash:   { type: String, default: null },
    url:    { type: String, default: null },
    loaderVariant: { type: String, default: 'morph' },
    loaderSize: { type: String, default: 'md' }
  },

  data() {
    return {
      html:            null, // Will be rendered as MotionLoader component initially
      rendered:        false, // Start with false to show loader
      reload:          false,
      showDetailModal: false,
      eventDetail:     null,
      eventItemTime:   null,
      eventItemType:   null,
      elementId:       null,
      vantaEffect:     [],
      isLoading:       true
    }
  },

  computed: {
    getEventItemIcon() {
      if (this.eventDetail?.eventItemType?.key_icon) {
        return [ 'fal ' + this.eventDetail.eventItemType.key_icon.icon ]
      }
      return [ 'fas fa-circle-notch fa-spin' ]
    }
  },

  methods: {
    htmlLoaded() {
      setTimeout(() => {
        this.initVata()
      }, 300)
    },

    htmlLoadedCustom() {
      // your custom hook
    },

    transformHtml(html) {
      return html.replaceAll('bgvata', this.elementId)
    },

    uuidv4() {
      return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = Math.random() * 16 | 0
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
      })
    },

    async getHtml() {
      const lang = window.appSettings?.appLanguage || 'de'
      const endpoint = this.url
        ? this.url
        : `https://${this.domain}/api/customer/widget/${this.id}/${this.hash}`

      // Set loading state and track start time
      this.isLoading = true
      this.rendered = false
      const loadingStartTime = Date.now()

      try {
        const { data } = await axios.get(endpoint, {
          params: {
            currentUrl: window.location.href,
            lang
          }
        })

        this.html = this.transformHtml(data.html)

        if (data.css_url) {
          const link = document.createElement('link')
          link.rel  = 'stylesheet'
          link.href = data.css_url
          document.head.appendChild(link)
          console.log('CSS Link', link)
        }

        await nextTick()
        this.htmlLoaded()
       
        // Ensure loader shows for at least 400ms so it's visible
        const elapsedTime = Date.now() - loadingStartTime
        const minDisplayTime = 400
        const remainingTime = Math.max(0, minDisplayTime - elapsedTime)

        setTimeout(() => {
          this.isLoading = false
          this.rendered = true
        }, remainingTime)

        await nextTick()
        this.htmlLoadedCustom()
      }
      catch (err) {
        console.error(err)
        this.isLoading = false
        this.html = '<div class="p-8 text-center text-red-500">Failed to load widget content</div>'
      }
    },

    initVata() {

    },

    async getDetailItem(url, eventItemTime, eventItemType) {
      this.showDetailModal = true
      this.eventDetail     = null
      this.eventItemTime   = eventItemTime
      this.eventItemType   = eventItemType

      try {
        const { data } = await axios.get(url)
        console.log('[SCHEDULE] Finding Position in index')

        this.eventDetail = data

        await nextTick()
        this.loadingDetails = false
        console.log('[POSTER] Latex Queue')
        setTimeout(() => {
          // MathJax.Hub.Queue(["Typeset",MathJax.Hub]);
        }, 200)
      }
      catch (err) {
        console.error(err)
      }
    },

    autoRefresh() {
      setTimeout(() => {
        if (this.reload) {
          this.getHtml()
        }
        this.autoRefresh()
      }, 10000)
    }
  },

  mounted() {
    this.elementId = 'bg_' + this.uuidv4()
    this.getHtml()
    this.autoRefresh()
  }
}
